import { Nullable, VATValues } from "../../api/types";
import { InputTypes } from "../../types";
import DataInputGenericForm, {
    DataInputGenericFormProps,
} from "../data-input-forms/DataInputGenericForm";
import Error from "../Error";

export default function VATTables({
    tablesData,
    loading,
    error,
}: {
    tablesData: Nullable<VATValues>;
    loading: boolean;
    error: any;
}) {
    if (error) return <Error />;
    if (!tablesData) return null;

    const vatData: DataInputGenericFormProps<VATValues>["formFields"] =
        Object.entries(tablesData.vat).map(([key, value]) => ({
            id: key,
            label: tablesData.labels[key as keyof VATValues["labels"]][0],
            value: value,
            originalValue: value,
            valueToDisplay: value,
            isSmallInput: true,
            type: InputTypes.NUMBER,
            required: false,
            disabled: true,
        }));
    const rcpData: DataInputGenericFormProps<VATValues>["formFields"] =
        Object.entries(tablesData.rcp).map(([key, value]) => ({
            id: key,
            label: tablesData.labels[key as keyof VATValues["labels"]][1],
            value: value,
            originalValue: value,
            valueToDisplay: value,
            isSmallInput: true,
            type: InputTypes.NUMBER,
            required: false,
            disabled: true,
        }));

    const tableClassName =
        "xl:h-full xl:max-h-[310px] max-xl:pr-1.5 max-xl:pt-1.5 gap-px xl:justify-between";

    const formClasses: DataInputGenericFormProps<VATValues>["classes"] = {
        table: tableClassName,
        root: "h-full flex flex-col",
        title: "xl:text-xl xl:pb-1",
    };

    return (
        <div className="flex flex-col gap-4 mt-0.5 xl:mt-0.5 xl:gap-[18px]">
            <DataInputGenericForm
                formTitle="VAT"
                formFields={vatData}
                formData={vatData}
                onFromValuesChange={() => {}}
                headers={["Parameter", "Measured"]}
                loading={loading}
                dense
                classes={formClasses}
            />
            <DataInputGenericForm
                formTitle="RCP"
                formFields={rcpData}
                formData={rcpData}
                onFromValuesChange={() => {}}
                headers={["Parameter", "Measured"]}
                loading={loading}
                dense
                classes={formClasses}
            />
        </div>
    );
}
